import { Time } from "../Helper/Time";

export interface StoreData {
    str_id?: number,
    str_login_str?: string,
    str_pass?: string,
    str_name?: string,
    str_open_date?: Date,
    str_close_date?: Date,
    str_unit?: Time,
}

export interface ObjectToStoreDataProps {
    str_id: number | string,
    str_login_str: string,
    str_name: string,
    str_open_date?: string,
    str_close_date?: string,
    str_unit?: string,
}
export const ObjectToStoreData = ({
    str_id,
    str_login_str,
    str_name,
    str_open_date,
    str_close_date,
    str_unit,
}: ObjectToStoreDataProps): StoreData => {
    return {
        str_id: typeof str_id === 'string' ? parseInt(str_id) : str_id,
        str_login_str: str_login_str,
        str_name: str_name,
        str_open_date: str_open_date ? new Date(str_open_date) : undefined,
        str_close_date: str_close_date ? new Date(str_close_date) : undefined,
        str_unit: str_unit ? new Time(str_unit) : undefined,
    }
}